import React, { useContext } from "react";
import { useParams } from "react-router";
import { RefActivity } from "../../../api/hooks";
import ActivityView from "../../../common/activity/ActivityView";
import { UserDetailContext } from "../../../context/user";

const UserDetailDashboard = () => {
    const { userId } = useParams<any>();
    return (
        <div>
            {userId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.Admin}
                    activityRefId={userId ?? ""}
                />
            )}
        </div>
    );
};

export default UserDetailDashboard;
